import React from 'react';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheck, CheckCircle2, BotMessageSquare } from 'lucide-react';
export function PricingSection() {
  return <Section background="rose" id="pricing" data-id="element-100">
      <div className="max-w-3xl mx-auto" data-id="element-101">
        <div className="text-center mb-12" data-id="element-102">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-103">
            Obtén acceso completo hoy
          </h2>
          <p className="text-lg text-gray-600" data-id="element-104">
            Comienza a comunicarte con seguridad hoy mismo.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl border-2 border-rose-500 p-8 md:p-12 flex flex-col relative" data-id="element-105">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-rose-500 text-white px-6 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide flex items-center gap-1 shadow-md whitespace-nowrap" data-id="element-106">
            Oferta Especial
          </div>

          <div className="text-center mb-8" data-id="element-107">
            <h3 className="text-3xl font-bold text-gray-900 mb-2" data-id="element-108">
              El Paquete Completo
            </h3>
            <p className="text-rose-600 font-medium" data-id="element-109">
              Ebook + 3 Bonos + Dra Sophi™ (IA)
            </p>
          </div>

          <div className="flex justify-center items-center gap-4 mb-10 flex-wrap" data-id="element-110">
            <img src="https://cdn.magicpatterns.com/uploads/6mHR95aYqiKteTwzfHgtr4/ChatGPT_Image_31_ene_2026,_03_36_32_p.m..png" alt="Portada del ebook Di Esto, No Aquello™" className="w-32 md:w-40 rounded-xl shadow-lg z-10" data-id="element-111" />
            <img src="https://cdn.magicpatterns.com/uploads/aTCy5VdBSAhh48UDpwnGBP/ChatGPT_Image_8_abr_2026,_10_48_22_a.m..png" alt="Dra Sophi - Asistente IA" className="w-32 md:w-40 rounded-xl shadow-lg z-20 -ml-8 md:-ml-12 border-4 border-white" data-id="element-112" />
          </div>

          <div className="flex justify-center items-end gap-4 md:gap-6 mb-10" data-id="element-113">
            <div className="flex flex-col items-center" data-id="element-114">
              <img src="https://cdn.magicpatterns.com/uploads/nBHycezXfKtJw92fLEEpgw/portada_bono_1.png" alt="Bono 1" className="w-20 md:w-24 rounded-lg shadow-md -rotate-2" data-id="element-115" />
              <span className="text-xs text-gray-500 mt-2" data-id="element-116">Bono 1</span>
            </div>
            <div className="flex flex-col items-center" data-id="element-117">
              <img src="https://cdn.magicpatterns.com/uploads/mfQsrshLShwGu2bTks1AtS/portada_bono_2.png" alt="Bono 2" className="w-20 md:w-24 rounded-lg shadow-md" data-id="element-118" />
              <span className="text-xs text-gray-500 mt-2" data-id="element-119">Bono 2</span>
            </div>
            <div className="flex flex-col items-center" data-id="element-120">
              <img src="https://cdn.magicpatterns.com/uploads/9Q4hcFw7ooaQM5KC9hdSP2/portada_bono_3.png" alt="Bono 3" className="w-20 md:w-24 rounded-lg shadow-md rotate-2" data-id="element-121" />
              <span className="text-xs text-gray-500 mt-2" data-id="element-122">Bono 3</span>
            </div>
          </div>

          <div className="bg-rose-50 rounded-2xl p-6 mb-8 border border-rose-100" data-id="element-123">
            <div className="flex items-center gap-3 mb-3" data-id="element-124">
              <div className="bg-rose-500 p-2 rounded-lg text-white" data-id="element-125">
                <BotMessageSquare className="h-6 w-6" data-id="element-126" />
              </div>
              <h4 className="font-bold text-gray-900 text-lg" data-id="element-127">
                Incluye: Dra Sophi™
              </h4>
            </div>
            <p className="text-sm text-gray-700 mb-4 italic" data-id="element-128">
              "Tu mentora personal que te dice exactamente qué decir en los
              momentos más difíciles — en tiempo real, sin juicio, sin esperar
              cita."
            </p>
            <ul className="space-y-2" data-id="element-129">
              <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-130">
                <span className="text-rose-500 font-bold" data-id="element-131">•</span>
                Respuestas personalizadas para TU situación real
              </li>
              <li className="flex items-start gap-2 text-sm text-gray-700" data-id="element-132">
                <span className="text-rose-500 font-bold" data-id="element-133">•</span>
                Disponible 24/7 — como tener una coach en tu bolsillo
              </li>
            </ul>
          </div>

          <div className="grid md:grid-cols-2 gap-4 mb-10" data-id="element-134">
            <ul className="space-y-3" data-id="element-135">
              <li className="flex items-start gap-3" data-id="element-136">
                <CheckCircle2 className="h-5 w-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-137" />
                <span className="text-gray-700 font-medium" data-id="element-138">
                  Ebook Di Esto, No Aquello™
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-139">
                <CheckCircle2 className="h-5 w-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-140" />
                <span className="text-gray-700" data-id="element-141">Acceso a Dra Sophi™ (IA)</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-142">
                <CheckCircle2 className="h-5 w-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-143" />
                <span className="text-gray-700" data-id="element-144">Descarga inmediata</span>
              </li>
            </ul>
            <ul className="space-y-3" data-id="element-145">
              <li className="flex items-start gap-3" data-id="element-146">
                <CheckCircle2 className="h-5 w-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-147" />
                <span className="text-gray-700" data-id="element-148">Bono 1: Guía de Mensajes</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-149">
                <CheckCircle2 className="h-5 w-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-150" />
                <span className="text-gray-700" data-id="element-151">
                  Bono 2: Cuando Él Se Cierra
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-152">
                <CheckCircle2 className="h-5 w-5 text-rose-500 flex-shrink-0 mt-0.5" data-id="element-153" />
                <span className="text-gray-700" data-id="element-154">
                  Bono 3: Scripts de Emergencia
                </span>
              </li>
            </ul>
          </div>

          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-155">
            <span className="text-5xl font-extrabold text-gray-900" data-id="element-156">
              $37.99
            </span>
            <span className="text-xl text-gray-400 line-through font-medium" data-id="element-157">
              $97
            </span>
          </div>

          <CTAButton fullWidth className="py-5 text-xl shadow-rose-200 mb-6" onClick={() => window.open('https://pay.hotmart.com/H104303411I?off=wqzh9j0e&checkoutMode=10&bid=1775166209201', '_blank')} data-id="element-158">
            Quiero el Paquete Completo — $37.99
          </CTAButton>

          <div className="flex items-center justify-center gap-2 text-gray-500 text-sm text-center" data-id="element-159">
            <ShieldCheck className="h-5 w-5 text-green-500 flex-shrink-0" data-id="element-160" />
            <span data-id="element-161">
              Garantía de satisfacción de 14 días. Si no te sirve, te devolvemos
              tu dinero.
            </span>
          </div>
        </div>
      </div>
    </Section>;
}